import { render, staticRenderFns } from "./swap-prompt.vue?vue&type=template&id=39d920a2&scoped=true&"
import script from "./swap-prompt.ts?vue&type=script&lang=ts&"
export * from "./swap-prompt.ts?vue&type=script&lang=ts&"
import style0 from "./swap-prompt.vue?vue&type=style&index=0&id=39d920a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d920a2",
  null
  
)

export default component.exports